import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";
import ExpImg1 from "./../assets/images/experiences/1.jpg";
import ExpImg2 from "./../assets/images/experiences/2.jpg";
import ExpImg3 from "./../assets/images/experiences/3.jpg";
import ExpImg4 from "./../assets/images/experiences/4.jpg";
import ExpImg5 from "./../assets/images/experiences/5.jpg";
import ExpImg6 from "./../assets/images/experiences/6.jpg";
// banners images
import AdventureTour2 from "./../assets/images/banners/Adventure-Tour-2.jpg";
import AdventureTour from "./../assets/images/banners/Adventure-Tour.jpg";
import FunGames2 from "./../assets/images/banners/Fun-Games-2.png";
import FunGames from "./../assets/images/banners/Fun-Games.jpg";
import HotDeals2 from "./../assets/images/banners/Hot-Deals-2.jpg";
import HotDeals from "./../assets/images/banners/Hot-Deals.jpg";
import NatureTours2 from "./../assets/images/banners/Nature-Tours-2.jpeg";
import NatureTours from "./../assets/images/banners/Nature-Tours.jpg";
import OutdoorActivities2 from "./../assets/images/banners/Outdoor-Activities-2.jpg";
import OutdoorActivities from "./../assets/images/banners/Outdoor-Activities.jpg";
import ReefIslandTours2 from "./../assets/images/banners/Reef-Island-Tours-2.jpg";
import ReefIslandTours from "./../assets/images/banners/Reef-Island-Tours.jpg";
import BannerComponent from "./BannerComponent";
import BannerSubComponent from "./BannerSubComponent";
import { fetchData } from "../services";
import { generateSku } from "./util/utils";
import TestimonialsComponent from "./TestimonialsComponent";
import AppConstants from "../appConstants";
import StarRating from "./common/StarRating";

const responsive = {
  desktop: {
    breakpoint: {
      max: 3000,
      min: 1200,
    },
    items: 4,
    partialVisibilityGutter: 40,
  },
  mobile: {
    breakpoint: {
      max: 575,
      min: 0,
    },
    items: 1,
    partialVisibilityGutter: 30,
  },
  mobile1: {
    breakpoint: {
      max: 991,
      min: 576,
    },
    items: 2,
    partialVisibilityGutter: 30,
  },
  tablet: {
    breakpoint: {
      max: 1199,
      min: 992,
    },
    items: 3,
    partialVisibilityGutter: 30,
  },
};

const LOVEEXPERIENCE = [
  {
    name: "Adventure Tours",
    sku: "/adventure-tours",
    image: ExpImg1,
    banners: [AdventureTour2, AdventureTour],
  },
  {
    name: "Outdoor Activities",
    sku: "/outdoor-activities",
    image: ExpImg2,
    banners: [OutdoorActivities2, OutdoorActivities],
  },
  {
    name: "Hot Deals",
    sku: "/hot-deals",
    image: ExpImg3,
    banners: [HotDeals2, HotDeals],
  },
  {
    name: "Fun & Games",
    sku: "/fun-and-games",
    image: ExpImg4,
    banners: [FunGames2, FunGames],
  },
  {
    name: "Zoo & Aquariums",
    sku: "/zoo-and-aquariums",
    image: ExpImg5,
    banners: [NatureTours2, NatureTours],
  },
  {
    name: "Reef & Island Cruises",
    sku: "/reef-and-island-cruises",
    image: ExpImg6,
    banners: [ReefIslandTours2, ReefIslandTours],
  },
];

function MainHomeComponent() {
  const navigate = useNavigate();
  const [banner, setBanner] = useState([]);
  const [topExperience, setTopExperience] = useState([]);
  const [topRestaurant, setTopRestaurant] = useState([]);
  const [topNightlife, setTopNightlife] = useState([]);

  useEffect(() => {
    async function getData() {
      const resp = await fetchData("getMainHomeData");
      if (resp.type === "success") {
        setBanner(resp.payload.banners);
        setTopExperience(resp.payload.topExperience);
        setTopRestaurant(resp.payload.topRestaurant);
        setTopNightlife(resp.payload.topNightlife);
      }
    }
    getData();
  }, []);

  const handleClickBooking = (tag, item) => {
    const name = generateSku(item.company_name);
    navigate(`/company/${name}`, { state: { companyName: item.company_name } });
  };

  const handleClickDinning = (tag, item) => {
    const name = generateSku(item.name);
    navigate(`/dining/${name}`, { state: { restaurantId: item.id } });
  };

  const handleClickNightlife = (tag, item) => {
    // const name = generateSku(item.activity_name);
    // navigate(`/${tag}/${name}`, { state: { activityId: item.id } });
  };

  const handleClickViewList = (item) => {
    navigate(`booking/sub-page${item.sku}`, {
      state: { title: item.name, banners: item.banners },
    });
  };

  return (
    <>
      {/* BANNER */}
      <BannerComponent
        banner={banner}
        title="TOUCH - iT"
        subTitle="Experience it all"
        button={{ title: "Search", link: AppConstants.routes.bookingSearch }}
      />

      {/* BEST PRICE GUARANTEED */}
      <BannerSubComponent />

      {/* TOP EXPERIENCE */}
      <section className="top-experiences te py-5">
        <div className="container">
          <h1 className="heading">Top experiences</h1>
          <div className="carousel-wrapper mt-4">
            <Carousel
              autoPlay={true}
              autoPlaySpeed={3000}
              infinite={true}
              responsive={responsive}
            >
              {topExperience.map((el, index) => {
                return (
                  <div className="item col-12" key={index}>
                    <div className="join-blocks join-blocks-new">
                      <div className="join-blocks-img">
                        <img
                          src={el.company_profile_photo}
                          className="img-fluid cursor-pointer"
                          alt={el.activity_name}
                          onClick={() =>
                            handleClickBooking("top-experiences", el)
                          }
                        />
                      </div>
                      <h4
                        className="cursor-pointer"
                        onClick={() =>
                          handleClickBooking("top-experiences", el)
                        }
                        style={{
                          fontSize: 14,
                          fontWeight: 600,
                          margin: "3px 0 0",
                        }}
                      >
                        {el.company_name}
                      </h4>
                      {/* <h4
                        className="cursor-pointer"
                        onClick={() =>
                          handleClickBooking("top-experiences", el)
                        }
                        style={{ fontSize: 14 }}
                      >
                        {el.activity_name}
                      </h4> */}
                      <StarRating rating={el?.total_ratings} />
                      {/* <span className="price">
                        {el?.display_price?.advertisePrice && (
                          <>
                            from <del>${el?.display_price?.advertisePrice}</del>
                          </>
                        )}
                        <ins>${el?.display_price?.price}</ins>
                      </span> */}
                      {el?.reviews && (
                        <span className="price">
                          <ins>Based on {el?.reviews} Reviews</ins>
                        </span>
                      )}
                    </div>
                  </div>
                );
              })}
            </Carousel>
          </div>
        </div>
      </section>

      {/* TOP RESTAURANT */}
      <section className="top-experiences top-deals py-5">
        <div className="container">
          <h1 className="heading">TOP RESTAURANTS</h1>
          <div className="carousel-wrapper mt-4">
            <Carousel
              autoPlay={true}
              autoPlaySpeed={3000}
              infinite={true}
              responsive={responsive}
            >
              {topRestaurant.map((el, index) => {
                return (
                  <div className="item col-12" key={index}>
                    <div className="join-blocks">
                      <div className="join-blocks-img">
                        <img
                          src={el.profile_photo}
                          className="img-fluid cursor-pointer"
                          alt={el.name}
                          onClick={() =>
                            handleClickDinning("top-restaurant", el)
                          }
                        />
                      </div>
                      <h4
                        className="cursor-pointer"
                        onClick={() => handleClickDinning("top-restaurant", el)}
                      >
                        {el.name}
                      </h4>
                      <StarRating rating={el?.total_ratings} />
                      {el?.reviews && (
                        <span className="price">
                          <ins>Based on {el?.reviews} Reviews</ins>
                        </span>
                      )}
                    </div>
                  </div>
                );
              })}
            </Carousel>
          </div>
        </div>
      </section>

      {/* TOP NIGHTLIFE */}
      <section className="top-experiences top-deals pt-5 d-none">
        <div className="container">
          <h1 className="heading">TOP NIGHTLIFE</h1>
          <div className="carousel-wrapper mt-4">
            <Carousel
              autoPlay={true}
              autoPlaySpeed={3000}
              infinite={true}
              responsive={responsive}
            >
              {topNightlife.map((el, index) => {
                return (
                  <div className="item col-12" key={index}>
                    <div className="join-blocks">
                      <div className="join-blocks-img">
                        <img
                          src={el.profile_photo}
                          className="img-fluid cursor-pointer"
                          alt={el.name}
                          onClick={() =>
                            handleClickNightlife("top-nightlife", el)
                          }
                        />
                      </div>
                      <h4
                        className="cursor-pointer"
                        onClick={() =>
                          handleClickNightlife("top-nightlife", el)
                        }
                      >
                        {el.name}
                      </h4>
                      <span className="stars">
                        <i className="fa fa-star"></i>
                        <i className="fa fa-star"></i>
                        <i className="fa fa-star"></i>
                        <i className="fa fa-star"></i>
                        <i className="fa fa-star-o"></i>
                        (4.6)
                      </span>
                    </div>
                  </div>
                );
              })}
            </Carousel>
          </div>
        </div>
      </section>

      {/* EXPERIENCES YOU'LL LOVE */}
      <section className="top-experiences take-me-there experiences py-5">
        <div className="container">
          <h1 className="heading">Experiences you'll love</h1>
          <div className="row g-4 mt-0">
            {LOVEEXPERIENCE.map((el, index) => {
              return (
                <div
                  className="col-lg-4 col-md-4 col-sm-6 col-xs-6"
                  key={index}
                >
                  {/* <Link to={el.sku}> */}
                  <div
                    className="join-blocks cursor-pointer"
                    onClick={() => handleClickViewList(el)}
                  >
                    <div className="join-blocks-img">
                      <img src={el.image} className="img-fluid" alt={el.name} />
                    </div>
                    <h4>{el.name}</h4>
                  </div>
                  {/* </Link> */}
                </div>
              );
            })}
          </div>
        </div>
      </section>

       {/* TESTIMONIALS */}
       <section className="top-experiences testimonials py-5">
        <TestimonialsComponent />
      </section>
    </>
  );
}

export default MainHomeComponent;
